import cx from 'classnames';
import {type FC, Fragment} from 'react';
import type {BreadcrumbPath} from '~/GalleryPB/types/gallery';

interface BreadcrumbProps {
  className?: string;
  path: BreadcrumbPath[];
}

export const Breadcrumb: FC<BreadcrumbProps> = ({className, path}) => (
  <div className={cx('gallery__breadcrumb-wrapper', className)}>
    {path.map((p, index) => (
      <Fragment key={`breadcrumb_path_piece_${p.text.toLowerCase().replaceAll(' ', '_')}`}>
        <a
          className="gallery__breadcrumb paragraph3"
          href={p.href}
          data-qa-id={`galleryBreadCrumb_${p.text.replaceAll(' ', '_')}`}
        >
          {p.text}
        </a>
        {index < path.length - 1 && <span>/</span>}
      </Fragment>
    ))}
  </div>
);
